import React from 'react';
// import moment from 'moment';
// import { Player } from 'video-react';

// import Player from 'react-player';

// const timestamp = moment().format('YYYYMMDDhh');

export const Video = (props) => {
  return (
    <video
      playsInline
      width="100%"
      height="auto"
      poster={`./static/images/trailer/poster.png`}
      controls={true}
      {...props}
    >
      <source src={`./static/video/trailer.mp4`} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};
